import Input from './input'
import TextArea from './TextArea'
export { InputSiteTypes, BorderTypes } from './input'
export type { InputProps, InputSiteType, BorderType } from './input'
export type { TextAreaProps } from './TextArea'
export { TextArea }
export default Input
